
const messages = {
  en: {
    userConfiguration: {
      title: 'User Configuration',
      sections: {
        userTitle: 'User settings',
        companyTitle: 'Company settings',
      },
      subtitle: 'Configure your user preferences',
      labels: {
        deposito: 'Deposit'
      },
      messages: {
        save: 'Save',
        saving: 'Saving...',
        saved: 'Configuration saved successfully',
        error: 'Error saving configuration',
        noDepositoSelected: 'No deposit selected',
        errorLoadingDepositos: 'Error loading deposits'
      },
      company: {
        pdfLogoHelp: 'This image appears on PDFs (invoices, budgets, purchase orders) for your company.',
        pdfLogoLabel: 'Logo image (PNG, JPEG or WebP)',
        preview: 'Preview',
        previewSaved: 'Saved logo (preview)',
        previewNewFile: 'Selected file (not saved yet)',
        logoStoredMessage: 'The company already has a logo configured.',
        logoReplaceHint: 'You selected a new file. Click Save to replace the current logo.',
        noPreview: 'No logo saved yet. PDFs will show an empty logo area.',
        pickFileFirst: 'Choose an image first.',
        savedLogo: 'Logo saved successfully',
        errorLoad: 'Could not load company logo',
        errorSave: 'Could not save logo',
        errorReadFile: 'Could not read the selected file',
      },
      companyConfig: {
        sectionTitle: 'Documents',
        mostrarPrecioEnRemitoLabel: 'Show price on delivery notes',
        saved: 'Configuration saved successfully',
        errorLoad: 'Could not load document settings',
        errorSave: 'Could not save document settings',
      },
    },
  },
  es: {
    userConfiguration: {
      title: 'Configuraci\u00F3n',
      sections: {
        userTitle: 'Configuraci\u00F3n de usuario',
        companyTitle: 'Configuraci\u00F3n de empresa',
      },
      subtitle: 'Configure sus preferencias de usuario',
      labels: {
        deposito: 'Dep\u00F3sito'
      },
      messages: {
        save: 'Guardar',
        saving: 'Guardando...',
        saved: 'Configuraci\u00F3n guardada exitosamente',
        error: 'Error al guardar la configuraci\u00F3n',
        noDepositoSelected: 'Sin dep\u00F3sito seleccionado',
        errorLoadingDepositos: 'Error al cargar los dep\u00F3sitos'
      },
      company: {
        pdfLogoHelp: 'Esta imagen se mostrar\u00E1 en los PDFs (facturas, presupuestos, \u00F3rdenes de compra) de la empresa.',
        pdfLogoLabel: 'Imagen del logo (PNG, JPEG o WebP)',
        preview: 'Vista previa',
        previewSaved: 'Logo guardado (vista previa)',
        previewNewFile: 'Archivo elegido (a\u00FAn no guardado)',
        logoStoredMessage: 'La empresa ya tiene un logo configurado.',
        logoReplaceHint: 'Elegiste un archivo nuevo. Puls\u00E1 Guardar para reemplazar el logo actual.',
        noPreview: 'A\u00FAn no hay logo guardado. En los PDFs el recuadro del logo quedar\u00E1 vac\u00EDo.',
        pickFileFirst: 'Eleg\u00ED una imagen primero.',
        savedLogo: 'Logo guardado correctamente',
        errorLoad: 'No se pudo cargar el logo de la empresa',
        errorSave: 'No se pudo guardar el logo',
        errorReadFile: 'No se pudo leer el archivo seleccionado',
      },
      companyConfig: {
        sectionTitle: 'Documentos',
        mostrarPrecioEnRemitoLabel: 'Mostrar precio en remitos',
        saved: 'Configuraci\u00F3n guardada correctamente',
        errorLoad: 'No se pudo cargar la configuraci\u00F3n de documentos',
        errorSave: 'No se pudo guardar la configuraci\u00F3n de documentos',
      },
    },
  },
  pt: {
    userConfiguration: {
      title: 'Configura\u00E7\u00E3o',
      sections: {
        userTitle: 'Configura\u00E7\u00E3o do usu\u00E1rio',
        companyTitle: 'Configura\u00E7\u00E3o da empresa',
      },
      subtitle: 'Configure suas prefer\u00EAncias de usu\u00E1rio',
      labels: {
        deposito: 'Deposito'
      },
      messages: {
        save: 'Salvar',
        saving: 'Salvando...',
        saved: 'Configura\u00E7\u00E3o salva com sucesso',
        error: 'Erro ao salvar a configura\u00E7\u00E3o',
        noDepositoSelected: 'Nenhum deposito selecionado',
        errorLoadingDepositos: 'Erro ao carregar os depositos'
      },
      company: {
        pdfLogoHelp: 'Esta imagem aparece nos PDFs (faturas, or\u00E7amentos, ordens de compra) da empresa.',
        pdfLogoLabel: 'Imagem do logo (PNG, JPEG ou WebP)',
        preview: 'Pr\u00E9-visualiza\u00E7\u00E3o',
        previewSaved: 'Logo salvo (pr\u00E9-visualiza\u00E7\u00E3o)',
        previewNewFile: 'Arquivo selecionado (ainda n\u00E3o salvo)',
        logoStoredMessage: 'A empresa j\u00E1 tem um logo configurado.',
        logoReplaceHint: 'Voc\u00EA selecionou um arquivo novo. Clique em Salvar para substituir o logo atual.',
        noPreview: 'Nenhum logo salvo ainda. Os PDFs mostrar\u00E3o a \u00E1rea do logo vazia.',
        pickFileFirst: 'Escolha uma imagem primeiro.',
        savedLogo: 'Logo salvo com sucesso',
        errorLoad: 'N\u00E3o foi poss\u00EDvel carregar o logo da empresa',
        errorSave: 'N\u00E3o foi poss\u00EDvel salvar o logo',
        errorReadFile: 'N\u00E3o foi poss\u00EDvel ler o arquivo selecionado',
      },
      companyConfig: {
        sectionTitle: 'Documentos',
        mostrarPrecioEnRemitoLabel: 'Mostrar pre\u00E7o em remessas',
        saved: 'Configura\u00E7\u00E3o salva com sucesso',
        errorLoad: 'N\u00E3o foi poss\u00EDvel carregar as configura\u00E7\u00F5es de documentos',
        errorSave: 'N\u00E3o foi poss\u00EDvel salvar as configura\u00E7\u00F5es de documentos',
      },
    },
  }
}

export default messages
